import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Link } from 'gatsby';
import InstarVisionCards from 'components/Software/macOS/InstarVision/Record/General/instarVisionCards';
import NavButtons from 'components/Software/macOS/InstarVision/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "InstarVision v3 für macOS",
  "path": "/Software/macOS/InstarVision/Record/General/",
  "dateChanged": "2018-01-25",
  "author": "Mike Polinowski",
  "excerpt": "Allgemeine Einstellungen für Ihre Videoaufnahme.",
  "image": "../../P_SearchThumb_InstarVision_Windows.png",
  "social": "/images/Search/P_SearchThumb_InstarVision_Windows.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_P-Windows-InstarVision_white.webp",
  "chapter": "Software"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <SEOHelmet title='InstarVision v3 für macOS' dateChanged='2018-01-25' author='Mike Polinowski' tag='INSTAR IP Camera' description='Das InstarVision Surveillance Center ist eine IP-Kamera-Software, die 64 Kameras gleichzeitig unterstützen kann, einschließlich Netzwerkkameras, USB-Kameras mit Fernzugriff und Sekundärinstallationen der Software.' image='/images/Search/P_SearchThumb_InstarVision_Windows.png' twitter='/images/Search/P_SearchThumb_InstarVision_Windows.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Software/macOS/InstarVision/Record/General/' locationFR='/fr/Software/macOS/InstarVision/Record/General/' crumbLabel="General" mdxType="BreadCrumbs" />
    <NavButtons mdxType="NavButtons" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/e4ac75ec4ece657754cb94630a9c740a/29114/Banner_en-InstarVision2-0_Record.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "16.521739130434785%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAYAAACTWi8uAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAf0lEQVQI143HPQrCQBRF4bcVXZ+FnWJ6i8yzGrER0uhWbCz9IRH7FNplJg7jEI5gCjvJhY/LEboIwfdiC68GggMSQ2etZb7IIAXEXDx6atBri94SWvVM9caU8a+8jKzuHdlSmU0n5GeHSPFAtjVSPJGdQ/bu94N4xusDo83x2x/YZ8DekD5/6wAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/e4ac75ec4ece657754cb94630a9c740a/e4706/Banner_en-InstarVision2-0_Record.avif 230w", "/de/static/e4ac75ec4ece657754cb94630a9c740a/d1af7/Banner_en-InstarVision2-0_Record.avif 460w", "/de/static/e4ac75ec4ece657754cb94630a9c740a/7f308/Banner_en-InstarVision2-0_Record.avif 920w", "/de/static/e4ac75ec4ece657754cb94630a9c740a/e1c99/Banner_en-InstarVision2-0_Record.avif 1380w", "/de/static/e4ac75ec4ece657754cb94630a9c740a/76ea5/Banner_en-InstarVision2-0_Record.avif 1840w", "/de/static/e4ac75ec4ece657754cb94630a9c740a/f696c/Banner_en-InstarVision2-0_Record.avif 1920w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/e4ac75ec4ece657754cb94630a9c740a/a0b58/Banner_en-InstarVision2-0_Record.webp 230w", "/de/static/e4ac75ec4ece657754cb94630a9c740a/bc10c/Banner_en-InstarVision2-0_Record.webp 460w", "/de/static/e4ac75ec4ece657754cb94630a9c740a/966d8/Banner_en-InstarVision2-0_Record.webp 920w", "/de/static/e4ac75ec4ece657754cb94630a9c740a/445df/Banner_en-InstarVision2-0_Record.webp 1380w", "/de/static/e4ac75ec4ece657754cb94630a9c740a/78de1/Banner_en-InstarVision2-0_Record.webp 1840w", "/de/static/e4ac75ec4ece657754cb94630a9c740a/882b9/Banner_en-InstarVision2-0_Record.webp 1920w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/e4ac75ec4ece657754cb94630a9c740a/81c8e/Banner_en-InstarVision2-0_Record.png 230w", "/de/static/e4ac75ec4ece657754cb94630a9c740a/08a84/Banner_en-InstarVision2-0_Record.png 460w", "/de/static/e4ac75ec4ece657754cb94630a9c740a/c0255/Banner_en-InstarVision2-0_Record.png 920w", "/de/static/e4ac75ec4ece657754cb94630a9c740a/b1001/Banner_en-InstarVision2-0_Record.png 1380w", "/de/static/e4ac75ec4ece657754cb94630a9c740a/161ec/Banner_en-InstarVision2-0_Record.png 1840w", "/de/static/e4ac75ec4ece657754cb94630a9c740a/29114/Banner_en-InstarVision2-0_Record.png 1920w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/e4ac75ec4ece657754cb94630a9c740a/c0255/Banner_en-InstarVision2-0_Record.png",
              "alt": "InstarVision v3 for Windows",
              "title": "InstarVision v3 for Windows",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <h2 {...{
      "id": "allgemeine-aufnahme-einstellungen",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#allgemeine-aufnahme-einstellungen",
        "aria-label": "allgemeine aufnahme einstellungen permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Allgemeine Aufnahme Einstellungen`}</h2>
    <h3 {...{
      "id": "speicherverwaltung",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#speicherverwaltung",
        "aria-label": "speicherverwaltung permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Speicherverwaltung`}</h3>
    <p>{`Sie müssen zuerst ein Aufzeichnungsverzeichnis festlegen, bevor Sie Funktionen ausführen können, die Dateien auf Ihre Festplatte schreiben. Standardmäßig ist Ihr Dokumentenordner ausgewählt. Wenn Ihr Server mehr als eine Festplatte verwendet, können Sie mehrere Verzeichnisse festlegen. Es wird empfohlen, die Verwendung der Hauptfestplatte (Betriebssystempartition) für die Datenspeicherung zu vermeiden.`}</p>
    <p>{`Die Software springt dann automatisch zum nächsten Verzeichnis, falls die aktive Festplatte keinen Speicherplatz mehr hat (Overflow). Verwenden Sie die Aufwärts- und Abwärtspfeile, um die Listenpositionen und die Reihenfolge festzulegen, in der Ihre Verzeichnisse verwendet werden. Um Netzwerkspeichergeräte verwenden zu können, müssen sie in Windows unter Windows Explorer wie lokale Festplatten angezeigt werden - `}<a href="http://www.howtogeek.com/school/windows-network-sharing/lesson8/all/" target="_blank" rel="noopener noreferrer">{`s. Tutorial hier`}</a>{`.`}</p>
    <p>{`InstarVision kann alte Aufzeichnungen nach einer bestimmten Anzahl von Tagen automatisch löschen. Aktivieren Sie die automatische Löschung und legen Sie die Anzahl der Tage fest, die Sie zum Speichern Ihrer Aufnahmen benötigen.`}</p>
    <h3 {...{
      "id": "aufnahmepfade",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#aufnahmepfade",
        "aria-label": "aufnahmepfade permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Aufnahmepfade`}</h3>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "502px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/f1629cfe333b5ae57be726844f5251a1/eea79/Image043.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "94.34782608695652%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAYAAACQjC21AAAACXBIWXMAAA7DAAAOwwHHb6hkAAADKklEQVQ4y31Uy24kNRStr2HNkn9AArHhA4AVEoIVWyTEKiEjJCYTdWfEhq8ACZYNiAmPISTDkDDp7nrZLle5XGW7njnouqqbUWBo6ci3XL7nnnt8q4PlcoGHD09xekpYYrlc+uf79z/H4cEBDg8PcHT0qV8JB4eHOD4+xmKxwMnJCR48OMHxYoEv7t3DV+9/gODZsxs8fnyOi4snuLz8A0//vPJxwji4kOAi26+MMQ/OORjnkJlAXUiofIJWOYKcx8i2V5DhNfLwGkX8F/LoGrXYwsoIJtvCiDVMnsIYC2MMKmMwOIPfpMWHv1t8duVw9NTi40uLoNIKY99M6NyMBn1jZ5gJrUPf9x5t1wO3A36WDq+vCrx7VuKdHxXefqQQaK3RdT26/i6GO+jRdZ1H23XA2OOycHjvJ4WjJxU+udD46FwjqKpqX/l57JJfjB5928DmwpP3toYtJALyxDkHa63HLm7b9p/E/ynk2s5b0LRTHHDOwFKGOErA0gSZEEiTFHVVYxgGNE2Dujb7YkTyX93s4kBK6QnCbQjOOOIwQhRGiOMYSZKgyHM/MkS42WxAnlOhF1nhL6UoCo+y1Kjr+l+HdtWJlBQ/3/pdK4I0TRAnCWj1atMU4zhiHMb9IVJEe7vfvs1hWsnvfcvki+AcmcgguPAvaW+z3UAp5VUzliKT85eSMq+SipAA6pC6oq+nLMvplsk7IiPSppkIw3CLUpc+IUli5Ln0Z+gsvd8RUlHioGIUB8Q+KRRQqvQtWWOw3txAlSVoTqMomi6HTZ2Q6vH2FkJwJEnq26Zp8YSmNrM64VdVKG9+HEVzy5NKWrMsg2DcjxR5Sjnr9RrhPBWekOTrUvskPd8yeUSkpIISSYGua5Rae9V2brk2BkprVLWBmnODyYvM324Sx56UCDljCLdbSJkDtyPQWlRSoGQJHP2hDMP0LDgKngJ9C4wjAqpOppq69hWca/xN056fycYhMR2+4xa/8AqrWONcGriuxxmv8OuMs8yhcN1ESCp32M0TxW0/ABjw5Y3BS19LvLZSePmbHG89KiFsi1dXCm+sFN78XuGVb3P8IBz+Bu2QjbjDdbcJAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/f1629cfe333b5ae57be726844f5251a1/e4706/Image043.avif 230w", "/de/static/f1629cfe333b5ae57be726844f5251a1/d1af7/Image043.avif 460w", "/de/static/f1629cfe333b5ae57be726844f5251a1/3f1f6/Image043.avif 502w"],
              "sizes": "(max-width: 502px) 100vw, 502px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/f1629cfe333b5ae57be726844f5251a1/a0b58/Image043.webp 230w", "/de/static/f1629cfe333b5ae57be726844f5251a1/bc10c/Image043.webp 460w", "/de/static/f1629cfe333b5ae57be726844f5251a1/20682/Image043.webp 502w"],
              "sizes": "(max-width: 502px) 100vw, 502px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/f1629cfe333b5ae57be726844f5251a1/81c8e/Image043.png 230w", "/de/static/f1629cfe333b5ae57be726844f5251a1/08a84/Image043.png 460w", "/de/static/f1629cfe333b5ae57be726844f5251a1/eea79/Image043.png 502w"],
              "sizes": "(max-width: 502px) 100vw, 502px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/f1629cfe333b5ae57be726844f5251a1/eea79/Image043.png",
              "alt": "InstarVision v3 for Windows",
              "title": "InstarVision v3 for Windows",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Die Farbe, in der der Aufnahmepfad dargestellt wird, schlüsselt sich wie folgt auf:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Orange`}</strong>{`: Aktives Aufnahmeverzeichnis.`}</li>
      <li parentName="ul"><strong parentName="li">{`Schwarz`}</strong>{`: Backup Aufnahmeverzeichnisse - die Software wird automatisch auf das nächste Backup Verzeichnis wechseln, sobald das aktive Verzeichnis nicht mehr verfügbar ist oder die Kapazität des Datenträgers erreicht wurde.`}</li>
      <li parentName="ul"><strong parentName="li">{`Rot`}</strong>{`: Nicht verfügbares Verzeichnis.`}</li>
    </ul>
    <h3 {...{
      "id": "videoaufnahme",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#videoaufnahme",
        "aria-label": "videoaufnahme permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Videoaufnahme`}</h3>
    <p><strong parentName="p">{`Video Kodierung`}</strong>{`: Setzen Sie das Dateiformat, den Medien Codec und die Qualität Parameter für die Videoaufnahme der einzelnen Videokanäle fest. Es wird empfohlen, immer die Kodierung zu wählen, die auch von der Kamera verwendet wird. Für INSTAR HD Kameras wäre dies h.264/mp3 - auf diese Weise muss die Software den Stream nicht mehr umwandeln und die Prozessorlast wird entsprechend minimiert. Es empfiehlt sich auch ein kleines Zeitinkrement für den Wert Neue Datei alle zu wählen. Sollte beim Schreiben einer Datei ein Fehler auftreten, wäre somit nur ein kleines Zeitfenster Ihrer Überwachung davon betroffen. Um eine große Anzahl kurzer Videodateien effizient zu handhaben, können Sie den INSTAR Player verwenden. Wenn Sie den Zeitstempel und den Kameranamen im Videostream der Kamera deaktiviert haben, können Sie diese im OSD (On-Screen Display) der Software einblenden. Nutzen Sie das Soft-OSD für MP4, MOV und MKV Aufnahmen, um den Prozessoraufwand weiter zu reduzieren - im Vergleich zu einem in das Video "eingebrannten" (Hard-OSD) Textzug.`}</p>
    <h3 {...{
      "id": "beschädigte-videodateien-nach-einem-software-absturz",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#besch%C3%A4digte-videodateien-nach-einem-software-absturz",
        "aria-label": "beschädigte videodateien nach einem software absturz permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Beschädigte Videodateien nach einem Software-Absturz`}</h3>
    <p>{`Sollte die Software während einer Aufnahme unerwarted beendet werden, z.B. durch einen Absturz des PCs, wird die Video Datei nicht abgeschlossen werden und ist ggf. für Ihren Video Player nicht mehr lesbar!`}</p>
    <p>{`Die Datei kann in vielen Fällen noch von kostenlosen Programmen wie dem `}<a href="http://www.videolan.org/vlc/download-windows.html" target="_blank" rel="noopener noreferrer">{`VLC Player`}</a>{` abgespielt werden.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      